import api from "../../api/apiInterceptor";

export function fetchAllUsers(page, pageSize, id, search) {
    return api.get(`/api/users?page=${page}&size=${pageSize}&installationId=${id}&query=${search}`)
}
